<app-centered-loading-indicator [atTop]="true"></app-centered-loading-indicator>
